import Link from 'next/link';
import CardActionArea from '@mui/material/CardActionArea';

export default function HelpArticleLink({ article }) {
  return (
    <CardActionArea>
      <Link
        href={`/help/article/${article.slug}`}
        className="tw-group tw-flex tw-items-center tw-justify-between tw-rounded-lg tw-px-2 tw-py-3 tw-transition-colors hover:tw-bg-primary-100 active:tw-bg-primary-200 sm:tw-px-4"
      >
        <h3 className="tw-text-sm tw-font-medium tw-text-gray-600 dark:tw-text-gray-200 group-hover:tw-text-primary-600 sm:tw-text-base tw-m-0">
          {article.title}
        </h3>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="-tw-ml-4 tw-h-4 tw-w-4 tw-text-gray-400 group-hover:tw-text-primary-600"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8.25 4.5l7.5 7.5-7.5 7.5"
          />
        </svg>
      </Link>
    </CardActionArea>
  );
}
